"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _LoginMenuOption = _interopRequireDefault(require("../LoginMenuOption"));
var _BigMemberLoginInfo = _interopRequireDefault(require("../BigMemberLoginInfo"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _BottomSheet = _interopRequireDefault(require("../BottomSheet"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _loginMenu = _interopRequireDefault(require("./login.menu.proptypes"));
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/* eslint-disable react/destructuring-assignment */
var LogOutButtonContainer = (0, _styledComponents.default)(_LoginMenuOption.default).withConfig({
  displayName: "LoginMenu__LogOutButtonContainer",
  componentId: "sc-1v29d6p-0"
})(["border-bottom:none;cursor:pointer;"]);
var MenuContainer = _styledComponents.default.div.withConfig({
  displayName: "LoginMenu__MenuContainer",
  componentId: "sc-1v29d6p-1"
})(["", ""], function (_ref) {
  var isMobile = _ref.isMobile,
    PositionType = _ref.PositionType,
    containerZIndex = _ref.containerZIndex,
    containerWidth = _ref.containerWidth;
  return !isMobile && (0, _styledComponents.css)(["box-shadow:0px 1px 4px rgba(0,0,0,0.16);position:", ";z-index:", ";width:", ";"], PositionType, containerZIndex, containerWidth);
});
var MenuOverlay = _styledComponents.default.div.withConfig({
  displayName: "LoginMenu__MenuOverlay",
  componentId: "sc-1v29d6p-2"
})(["position:fixed;top:0;bottom:0;left:0;right:0;transition:ease-out 0.3s;opacity:0.7;", ""], function (props) {
  return (0, _styledComponents.css)(["background-color:", ";z-index:", ";"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.backgroundColor.black;
  }, props.overlayZIndex);
}); // eslint-disable-next-line react/prop-types

var LogOutButton = function LogOutButton(_ref3) {
  var data = _ref3.data,
    doLogout = _ref3.doLogout,
    tabIndex = _ref3.tabIndex,
    setShowMenu = _ref3.setShowMenu;
  var handleClick = function handleClick() {
    doLogout(true);
    setShowMenu(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: handleClick,
    role: "button",
    onKeyPress: handleClick,
    tabIndex: tabIndex
  }, /*#__PURE__*/_react.default.createElement(LogOutButtonContainer, {
    data: data,
    accessible: false,
    stopPropagation: "false"
  }));
};
var LoginMenu = function LoginMenu(props) {
  var data = props.data,
    show = props.show,
    theme = props.theme,
    accessible = props.accessible,
    customProperties = props.customProperties,
    bigPoints = props.bigPoints,
    loyaltyTier = props.loyaltyTier,
    containerWidth = props.containerWidth,
    bigmemberId = props.bigmemberId,
    isClosed = props.isClosed,
    doLogout = props.doLogout,
    overlayZIndex = props.overlayZIndex,
    isMobile = props.isMobile,
    bottomSheetZIndex = props.bottomSheetZIndex,
    containerZIndex = props.containerZIndex,
    PositionType = props.PositionType,
    showBigLoyaltyPoints = props.showBigLoyaltyPoints,
    creditBalance = props.creditBalance,
    showCreditBalance = props.showCreditBalance;
  var _useState = (0, _react.useState)(show),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showMenu = _useState2[0],
    setShowMenu = _useState2[1];
  var MenuContainerRef = _react.default.useRef(null);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  (0, _react.useEffect)(function () {
    setShowMenu(show);
  }, [show]);
  var overlayClick = function overlayClick() {
    setShowMenu(false);
    isClosed(true);
  };
  var hideDesktopLoginMenu = function hideDesktopLoginMenu(e) {
    if (!isMobile && e.target && e.target.id !== 'logout' && !MenuContainerRef.current.contains(e.target)) {
      setShowMenu(false);
      isClosed(true);
    }
  };
  (0, _react.useEffect)(function () {
    if (typeof document !== 'undefined') {
      if (showMenu) {
        document.addEventListener('click', hideDesktopLoginMenu);
      } else {
        document.removeEventListener('click', hideDesktopLoginMenu);
      }
    }
    return function () {
      if (typeof document !== 'undefined') {
        document.removeEventListener('click', hideDesktopLoginMenu);
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMenu]);
  var listMenu = function listMenu() {
    var arr = [];
    for (var i = 0; i < data.length; i += 1) {
      var key = Object.keys(data[i]).toString();
      switch (key) {
        case _constants.CONTRACT_CONSTANT_KEY.MEMBER:
          arr.push( /*#__PURE__*/_react.default.createElement(_BigMemberLoginInfo.default, {
            key: key,
            id: key,
            data: data[i][key],
            bigmemberId: bigmemberId,
            loyaltyTier: loyaltyTier,
            bigPoints: bigPoints,
            accessible: accessible,
            showBigLoyaltyPoints: showBigLoyaltyPoints,
            creditBalance: creditBalance,
            showCreditBalance: showCreditBalance
          }));
          break;
        case _constants.CONTRACT_CONSTANT_KEY.NAVIGATION:
          arr.push( /*#__PURE__*/_react.default.createElement(_LoginMenuOption.default, {
            id: key,
            key: key,
            data: data[i][key],
            accessible: accessible
          }));
          break;
        case _constants.CONTRACT_CONSTANT_KEY.LOGOUT:
          arr.push( /*#__PURE__*/_react.default.createElement(LogOutButton, {
            key: key,
            id: key,
            data: data[i][key],
            doLogout: doLogout,
            tabIndex: tabIndex,
            setShowMenu: setShowMenu
          }));
          break;
        default:
          break;
      }
    }
    return arr;
  };
  var MenuContainerBox = function MenuContainerBox() {
    return /*#__PURE__*/_react.default.createElement(MenuContainer, (0, _extends2.default)({
      ref: MenuContainerRef,
      id: "login-menu",
      isMobile: isMobile,
      PositionType: PositionType,
      containerWidth: containerWidth
    }, customProperties, {
      containerZIndex: containerZIndex,
      onBlur: function onBlur(e) {
        return _utilities.default.outsideOfParent(e, MenuContainerRef, overlayClick);
      }
    }), listMenu());
  };
  var Container = function Container() {
    if (isMobile) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MenuOverlay, {
        onClick: overlayClick,
        overlayZIndex: overlayZIndex
      }), /*#__PURE__*/_react.default.createElement(_BottomSheet.default, {
        zIndex: bottomSheetZIndex
      }, MenuContainerBox()));
    }
    return MenuContainerBox();
  };
  var getMain = function getMain() {
    if (!showMenu || !data) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
    return Container();
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
LoginMenu.propTypes = _loginMenu.default.PropTypes;
LoginMenu.defaultProps = _loginMenu.default.DefaultProps;
var _default = LoginMenu;
exports.default = _default;